// services/guestLinkService.js
import { apiService } from "./api";

export const guestLinkService = {
  // Get all guest links
  getGuestLinks: async (page = 1, limit = 10, search = "") => {
    const params = { page, limit };
    if (search) params.search = search;

    return await apiService.get("/guest-links", { params });
  },

  // Create guest link
  createGuestLink: async (guestLinkData) => {
    return await apiService.post("/guest-links", guestLinkData);
  },

  // Validate guest token (used for both regular links and QR codes)
  validateGuestToken: async (token) => {
    return await apiService.get(`/guest-links/validate/${token}`);
  },

  // Update guest link
  updateGuestLink: async (id, guestLinkData) => {
    return await apiService.put(`/guest-links/${id}`, guestLinkData);
  },

  // Delete guest link
  deleteGuestLink: async (id) => {
    return await apiService.delete(`/guest-links/${id}`);
  },

  // Get guest link stats
  getGuestLinkStats: async () => {
    return await apiService.get("/guest-links/stats");
  },
};

export default guestLinkService;
